import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      '@keyframes slideAnimation': {
        '0%': { opacity: 0, transform: 'translateY(75px)', height: '0px' },
        '20%': { opacity: 0, transform: 'translateY(75px)', height: '40px' },
        '25%': { opacity: 0, height: '40px' },
        '35%': { opacity: 1, height: '40px' },
        '100%': { transform: 'translateY(0px)', height: '40px' },
      },

      '@keyframes slide': {
        '0%': { opacity: 0, transform: 'translateY(75px)' },
        '100%': { opacity: 1, transform: 'translateY(0px)' },
      },
      root: {
        overflow: 'hidden',
        border: '1px solid #CDD3CD',
        borderRadius: '4px',
        marginBottom: '1rem',

        '&.liberada': {
          borderColor: sicrediColor.primarySicredi,
        },

        '&.bloqueada': {
          borderColor: sicrediColor.dangerSicrediLight,
          '& > .Mui-expanded': {
            borderColor: sicrediColor.dangerSicrediLight,
          },
        },

        '& > div': {
          border: 'none',
          '& .MuiIconButton-edgeEnd': {
            marginRight: '-7px',

            [theme.breakpoints.down('sm')]: {
              padding: '0px',
              marginRight: '0px',
            },
          },

          '&.Mui-expanded': {
            borderBottom: '1px solid #CDD3CD !important',
            '& > span': {
              display: 'none',
            },
          },
        },
        '&.Mui-expanded': {
          flexDirection: 'column',
        },

        '$tabPauta + &': {
          borderRadius: '4px',
          marginTop: 0,
          '&.Mui-expanded': {
            marginTop: 0,
            borderColor: sicrediColor.primarySicredi,
          },
        },
        '&:before': {
          content: 'unset',
        },
      },
      buttonStatus: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: '0.5rem 0rem',
        fontFamily: '"Nunito", sans-serif',
        userSelect: 'none',
        animation: `0.73s $slideAnimation cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
        cursor: 'pointer',

        '& > div': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

          '& > svg': {
            width: '22px',
            marginRight: '0.3rem',
          },
        },

        '&.verPauta': {
          background: '#EFEFEF',
          color: '#5A645A',
        },

        '&.votarNaPauta': {
          background: '#3FA110',
          color: '#FFFFFF',
        },

        '&.votoEnviado': {
          background: '#EFEFEF',
          color: '#5A645A',
        },

        '&.alterarVoto': {
          background: sicrediColor.primarySicrediLight,
          color: sicrediColor.primarySicrediDark,
        },
        '&.pautaBloqueada': {
          background: '#FFB4B4',
          color: '#AB4745',
        },
      },
      votoSelecionado: {
        width: '98.15%',
        marginLeft: '0.3rem',
        padding: '0.5rem 0px',
        position: 'relative',
        userSelect: 'none',
        cursor: 'pointer!important',

        '&:before': {
          content: '""',
          width: '99.1%',
          height: '1px',
          background: '#CDD3CD',
          position: 'absolute',
          top: '0px',
          left: '10px',

          [theme.breakpoints.down('sm')]: {
            width: '93.5%',
          },
        },
      },
      title: {
        color: sicrediColor.secondarySicrediDarker,
        flex: 'auto',
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 700,
        fontSize: 16,
        paddingRight: theme.typography.pxToRem(15),
        textAlign: 'left',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      anexo: {
        marginTop: '12px',
      },
      chips: {
        display: 'flex',
        flexShrink: 0,
        // width: '213px',
        marginRight: '12px',
        // margin: theme.spacing(0, 2),
        [theme.breakpoints.down('sm')]: {
          '& > div:nth-child(1) > span': {
            marginLeft: '-12px',
          },
        },
      },
      chip: {
        pointerEvents: 'none',
        color: '#5A645A',
        '&.MuiChip-colorPrimary': {
          backgroundColor: sicrediColor.primarySicrediLight,
          color: sicrediColor.primarySicrediDark,
          '& > .MuiChip-iconColorPrimary': {
            color: sicrediColor.primarySicrediDark,
          },
        },
        '&.MuiChip-colorPrimary.Mui-disabled': {
          backgroundColor: sicrediColor.dangerSicrediLight,
          color: sicrediColor.dangerSicrediDark,
          '& > .MuiChip-iconColorPrimary': {
            color: sicrediColor.dangerSicrediDark,
          },
        },
      },
      details: {
        flexDirection: 'column',
      },
      actionButtons: {
        [theme.breakpoints.down(992)]: {
          display: 'flex',
          flexDirection: 'column',

          '& > p': {
            padding: '0px',
            marginBottom: '1rem',
          },

          '& > button': {
            width: '100%',
            margin: '0px',
            borderRadius: '4px!important',
            padding: '5px!important',

            '&:not(:first-child)': {
              marginLeft: '0px!important',
            },
          },
        },
      },
      descricao: {
        lineHeight: '24px',
        fontFamily: '"Exo 2", sans-serif',
        color: sicrediColor.secondarySicrediDarker,
        marginBottom: '1rem',
        wordBreak: 'break-word',
      },
      direcionamento: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '24px',
        borderBottomWidth: 1,
        borderBottomColor: sicrediColor.secondarySicrediLight,
        borderBottomStyle: 'dashed',
        color: sicrediColor.secondarySicrediDarker,
        marginBottom: '0.6rem',
      },
      item: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 14,
        lineHeight: '24px',
        borderBottomWidth: 1,
        borderBottomColor: sicrediColor.secondarySicrediLight,
        borderBottomStyle: 'dashed',
        marginTop: theme.spacing(2),
        maxWidth: 'unset',
        display: 'flex',
        '& .MuiButton-root': {
          flexShrink: 0,
        },
      },
      itemAssociado: {
        display: 'flex',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderBottomColor: sicrediColor.secondarySicrediLight,
        borderBottomStyle: 'dashed',
        padding: '4px 0px',

        '&::first-child': {
          paddingTop: '1rem',
        },

        '& > .MuiFormControlLabel-root': {
          flex: 'auto',

          '& > .MuiFormControlLabel-label': {
            fontFamily: '"Nunito", sans-serif',
            fontSize: 14,
            lineHeight: '24px',
            marginTop: '3px',
            marginLeft: '-1px',
          },
        },
      },
      timer: {
        backgroundColor: 'transparent',
        marginRight: 12,
        color: sicrediColor.secondarySicredi,
        fontFamily: '"Exo 2", sans-serif!important',
        '& > span': {
          fontFamily: '"Exo 2", sans-serif!important',
        },
      },
      acoes: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '0 -4px',
        '@media (max-width: 768px)': {
          justifyContent: 'center',
        },
        '@media (max-width: 550px)': {
          flexDirection: 'column',
        },
      },
      botaoAcoes: {
        [theme.breakpoints.down('xs')]: {
          width: '100%',
          margin: '4px 0',
        },
      },
      botaoVotoPresencial: {
        backgroundColor: sicrediColor.primarySicrediLight,
        color: sicrediColor.primarySicrediDark,
      },
      botaoEditar: {
        margin: '0 4px',
        '@media (max-width: 768px)': {
          flex: 1,
        },
        '@media (max-width: 550px)': {
          margin: '4px 0',
          width: '100%',
        },
      },
      botaoDeletar: {
        backgroundColor: '#e60000',
        margin: '0 4px',
        '@media (max-width: 768px)': {
          flex: 1,
        },
        '@media (max-width: 550px)': {
          margin: '4px 0',
          width: '100%',
        },
        '&:hover': {
          backgroundColor: '#d21818',
        },
      },
      buttonEleicao: {
        float: 'right',
        color: sicrediColor.primarySicrediLight,
        [theme.breakpoints.down('sm')]: {
          width: '30%',
        },
      },
      buttonEleicaoAssociado: {
        float: 'right',
        color: sicrediColor.primarySicrediLight,
        width: '20%',
        [theme.breakpoints.down('sm')]: {
          width: '30%',
        },
      },
      iconButton: {
        [theme.breakpoints.down('sm')]: {
          width: '35%',
        },
      },
      textButtonEleicao: {
        color: sicrediColor.primarySicrediDark,
        fontSize: '12px',
        marginLeft: '5px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '10px',
        },
      },
      arrow: {
        transform: 'rotate(180deg)',
        color: sicrediColor.primarySicredi,
        width: '18px',

        '&.bloqueada': {
          color: sicrediColor.dangerSicrediDark,
        },
      },

      disableArrow: {
        visibility: 'hidden',
      },
      summary: {
        padding: '0.8rem 1rem',
        '& .MuiExpanded': {
          borderBottom: `1px solid ${sicrediColor.secondarySicrediLight}!important`,
        },
        '& .MuiAccordionSummary-content': {
          alignItems: 'center',
          justifyContent: 'space-between',
          '&.Mui-expanded': {
            [theme.breakpoints.up('md')]: {
              margin: '12px 0',
            },
          },
        },
        [theme.breakpoints.down('sm')]: {
          alignItems: 'flex-start',
          padding: theme.spacing(2),
          '& .MuiIconButton-edgeEnd': {
            marginTop: '-5px',
          },

          '& .MuiExpansionPanelSummary-content': {
            flexDirection: 'column-reverse',
            alignItems: 'flex-start',
          },

          '& .MuiAccordionSummary-content': {
            flexDirection: 'column-reverse',
            alignItems: 'flex-start',
            margin: '0px',

            '& > p': {
              marginTop: '1rem',
            },
          },
        },
      },
      summaryNone: {
        display: 'none',
      },
      adviceVoto: {
        flex: 'auto',
        fontFamily: '"Nunito", sans-serif',
        fontSize: 12,
        lineHeight: '24px',
        color: sicrediColor.secondarySicrediDarker,
        textAlign: 'justify',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          flexShrink: 0,
        },

        '&.canVote': {
          marginTop: '1rem',
        },
      },
      labelRadio: {
        flex: 'auto',
        whiteSpace: 'normal',
      },
      flagIcon: {
        width: 20,
        height: 20,
        color: sicrediColor.secondarySicredi,
        margin: theme.spacing('auto', 1, 'auto', 0),
      },
      tabPauta: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        borderRadius: '4px 4px 0 0',
        borderBottom: 0,
        marginBottom: '-3px',
        flex: 'none',
        width: 'fit-content',
        padding: '12px 12px 12px 6px',
        '& .MuiButton-root': {
          minHeight: 'unset',
          '& .MuiButton-label': {
            padding: '0 8px !important',
            lineHeight: '22px !important',
          },
        },

        '& > button': {
          padding: '10px 16px 13px 16px!important',
          borderRadius: '0px!important',

          [theme.breakpoints.down('sm')]: {
            padding: '8px 13px 11px 13px!important',
          },
        },

        '&.liberada': {
          borderColor: sicrediColor.primarySicredi,
        },

        '&.bloqueada': {
          borderColor: '#ffb4b4',
        },
      },
      tabPautaInfo: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        fontWeight: 700,
        fontSize: 15,
        color: sicrediColor.secondarySicrediDarker,
        '& > svg': {
          width: 20,
          height: 20,
          color: sicrediColor.primarySicredi,
          margin: theme.spacing('auto', 1),
        },
      },
      alterarVotoText: {
        margin: '1rem 0rem',
      },

      votoEnviado: {
        // userSelect: 'none',
        // pointerEvents: 'none',
        position: 'relative',
        height: '400px',
        background: '#fff',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexDirection: 'column',
        fontFamily: '"Exo 2", sans-serif',
        color: sicrediColor.secondarySicrediDarker,

        '& > section': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          animation: `0.73s $slide cubic-bezier(0.4, 0, 0.2, 1) 0ms`,

          '& > p': {
            fontFamily: '"Exo 2", sans-serif',
            marginTop: '1rem',
            animation: `0.76s $slide cubic-bezier(0.1, 0, 0.2, 1) 0ms`,
            color: sicrediColor.secondarySicrediDarker,
            fontWeight: 500,
          },

          '& > svg': {
            fontSize: '65px',
          },
        },
      },
      closeButton: {
        position: 'absolute',
        top: '1rem',
        right: '1rem',
        animation: `0.67s $slide cubic-bezier(0.4, 0, 0.2, 1) 0ms`,

        '& > span > svg': {
          fontSize: 16,
        },

        [theme.breakpoints.down('sm')]: {
          top: '0.6rem',
          right: '0.3rem',
        },
      },
      votoEnviadoBottom: {
        width: '100%',
        background: '#3FA110',
        padding: '7px',
        position: 'absolute',
        bottom: 0,
        color: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: '"Nunito", sans-serif',
        lineHeight: '24px',
        animation: `1s $slide cubic-bezier(0.2, 0, 0.1, 1) 0ms`,

        '& > svg': {
          width: '20px',
          marginRight: '10px',
        },

        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
    }),
  { name: 'AssembleiaPauta' }
);
